import {
  ApplicationEventNames,
  ApplicationEvents,
  UserEventNames,
  UserEvents
} from "@tt-app/models";

export const LOGGER_AWS_KINESIS_REGION = process.env.VUE_APP_AWS_KINESIS_REGION;
export const LOGGER_AWS_KINESIS_STREAM_NAME = process.env.VUE_APP_AWS_KINESIS_STREAM_NAME || "";
export const LOGGER_AWS_ID_POOL = process.env.VUE_APP_AWS_LOGGER_ID_POOL || "";

export enum LOGGER_RESULT {
  FAILURE = -1,
  OTHER,
  SUCCESS
}

const applicationEventNames: { [key in ApplicationEventNames]: string } = {
  AUDIO_RECORD_FOLLOWING_USER_AUDIO_RECORD_START: "AudioRecordFollowingUserAudioRecordStart",
  AUDIO_RECORD_START: "AudioRecordStart",
  AUDIO_RECORD_STOP: "AudioRecordStop",
  AUDIO_RECORDED: "AudioRecorded",
  CONNECTION_METHOD_CHECK: "ConnectionMethodCheck",
  EXAMPLE_AUDIO_PLAY: "ExampleAudioPlay",
  EXERCISE_DETAILS_REQUEST: "ExerciseDetailsRequest",
  EXERCISE_DETAILS_RESPONSE: "ExerciseDetailsResponse",
  EXERCISE_END_REQUEST: "ExerciseEndRequest",
  EXERCISE_END_RESPONSE: "ExerciseEndResponse",
  EXERCISE_LOG_REQUEST: "ExerciseLogRequest",
  EXERCISE_LOG_RESPONSE: "ExerciseLogResponse",
  EXERCISE_START_REQUEST: "ExerciseStartRequest",
  EXERCISE_START_RESPONSE: "ExerciseStartResponse",
  PETT_REQUEST: "PETTRequest",
  PETT_RESPONSE: "PETTResponse",
  USER_AUDIO_PLAY: "UserAudioPlay"
};

const userEventNames: { [key in UserEventNames]: string } = {
  DICTIONARY_MODAL_CLOSE: "DictionaryModalClose",
  DICTIONARY_MODAL_OPEN: "DictionaryModalOpen",
  EXAMPLE_AUDIO_PLAY_PRESS: "ExampleAudioPlayPress",
  EXERCISE_CLOSE: "ExerciseClose",
  EXERCISE_CLOSE_CANCELLATION: "ExerciseCloseCancellation",
  EXERCISE_CLOSE_CONFIRMATION: "ExerciseCloseConfirmation",
  EXERCISE_FINISH: "ExerciseFinish",
  EXERCISE_NEXT: "ExerciseNext",
  EXERCISE_OPEN: "ExerciseOpen",
  EXERCISE_REVIEW: "ExerciseReview",
  EXERCISE_REVIEW_BACKWARD: "ExerciseReviewBackward",
  EXERCISE_REVIEW_CHANGE_PAGE: "ExerciseReviewChangePage",
  EXERCISE_REVIEW_FORWARD: "ExerciseReviewForward",
  EXERCISE_SKIP: "ExerciseSkip",
  EXERCISE_TRY_AGAIN: "ExerciseTryAgain",
  TT4W_CLOSE: "TT4WClose",
  USER_AUDIO_PLAY_PRESS: "UserAudioPlayPress",
  USER_AUDIO_RECORD_START: "UserAudioRecordStart",
  USER_AUDIO_RECORD_STOP: "UserAudioRecordStop"
};

const reduceNamesToEvents: (
  previousValue: any,
  currentValue: any,
  currentIndex: number,
  array: any[]
) => any = (accumulator, [key, name]) => {
  accumulator[key] = {
    FAILURE: {
      MeasureName: name,
      MeasureValue: LOGGER_RESULT.FAILURE,
      MeasureValueType: "BIGINT"
    },
    OTHER: {
      MeasureName: name,
      MeasureValue: LOGGER_RESULT.OTHER,
      MeasureValueType: "BIGINT"
    },
    SUCCESS: {
      MeasureName: name,
      MeasureValue: LOGGER_RESULT.SUCCESS,
      MeasureValueType: "BIGINT"
    }
  };
  return accumulator;
};

const applicationEvents = Object.entries(applicationEventNames).reduce<ApplicationEvents>(
  reduceNamesToEvents,
  {} as ApplicationEvents
);

const userEvents = Object.entries(userEventNames).reduce<UserEvents>(
  reduceNamesToEvents,
  {} as UserEvents
);

export const LOGGER_EVENTS = {
  APPLICATION: applicationEvents,
  USER: userEvents
};
